
const modelwithSearchBar = document.querySelector('.js-with-searchbar');

if (modelwithSearchBar) {

    // Variables
    const searchContainer = document.querySelector('#js-searchBarContainer');
    const searchResults = searchContainer.querySelector('#js-searchBarResults');

    // if (searchResults.classList.contains('showX')) {
        document.addEventListener("mouseup", function(event) {
            if (!searchContainer.contains(event.target)) {
                searchContainer.classList.remove('search-container-open')
                searchResults.classList.remove('showX')
                searchResults.classList.add('hideX')
                searchResults.classList.add('hide')

                // console.log('remove searchresult click outside')
            }
        });
    // }

}